(() => {
  const popover = document.querySelector("[data-membership-popover]");
  if (!popover || typeof popover.showModal !== "function") return;

  const amountElement = popover.querySelector("[data-membership-amount]");
  let opener = null;
  let pointerDownOnBackdrop = false;

  const open = ({ amount } = {}) => {
    if (popover.open) return;
    if (amount && amountElement) amountElement.textContent = amount;

    opener = document.activeElement;
    popover.showModal();
  };

  popover.addEventListener("pointerdown", (event) => {
    pointerDownOnBackdrop = event.target === popover;
  });

  popover.addEventListener("click", (event) => {
    if (event.target === popover) {
      if (pointerDownOnBackdrop) popover.close("dismiss");
      return;
    }

    const action = event.target.closest("[data-membership-action]")?.dataset.membershipAction;
    if (action) popover.close(action);
  });

  popover.addEventListener("close", () => {
    const action = popover.returnValue || "dismiss";
    popover.returnValue = "";

    if (opener?.isConnected && document.activeElement !== opener) opener.focus?.();
    opener = null;

    popover.dispatchEvent(
      new CustomEvent("membership-popover:close", { bubbles: true, detail: { action } })
    );
  });

  window.openMembershipPopover = open;
})();
